import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ComboModel } from 'app/shared/components/combo/combo-model';
import { ActionConfirmationDialogComponent } from '../action-confirmation-dialog/action-confirmation-dialog.component';
import { ComboDialogBoxDataModel } from './combo-dialog-box-data.model';
import { ComboDialogBoxFormGroup } from './combo-dialog-box-form-group';
import { AbstractActionConfirmationDialogComponent } from '../abstract-action-confirmation-dialog/abstract-action-confirmation-dialog.component';
import { ComboComponent } from '../../../../shared/components/combo/combo.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-action-confirmation-combo-dialog',
  styleUrls: ['./action-confirmation-combo-dialog.component.scss'],
  templateUrl: './action-confirmation-combo-dialog.component.html',
  imports: [AbstractActionConfirmationDialogComponent, FormsModule, ReactiveFormsModule, ComboComponent],
})
export class ActionConfirmationComboDialogComponent {
  public data: ComboDialogBoxDataModel;
  public dialogRef = inject<MatDialogRef<ActionConfirmationDialogComponent>>(MatDialogRef);
  public formGroup: FormGroup<ComboDialogBoxFormGroup>;

  private _data = inject<ComboDialogBoxDataModel>(MAT_DIALOG_DATA);

  public constructor() {
    const _data = this._data;

    this.data = _data;
    if (!this._data.acceptLabel) {
      this.data.acceptLabel = 'Oui';
    }
    if (!this._data.declineLabel) {
      this.data.declineLabel = 'Non';
    }
    this._createForm(_data);
  }

  public onAcceptClickedHandler(): void {
    if (this._data.onAcceptWithCombo) {
      this._data.onAcceptWithCombo(this.formGroup.controls?.selectedValue?.value);
    }
    this.dialogRef.close(true);
  }

  public onCloseClickedHandler(): void {
    this.dialogRef.close(true);
  }

  public onDeclineClickedHandler(): void {
    if (this._data.onDecline) {
      this._data.onDecline();
    }
    this.dialogRef.close(false);
  }

  private _createForm(dialogBoxData: ComboDialogBoxDataModel): void {
    this.formGroup = new FormGroup<ComboDialogBoxFormGroup>({
      options: new FormControl<ComboModel[]>(dialogBoxData.options),
      selectedValue: new FormControl<ComboModel>(dialogBoxData.selectedValue!),
    });
  }
}
